import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    langLocale:localStorage.getItem("langLocale"),
    token:localStorage.getItem("token"),
    centerId:localStorage.getItem("centerId"),
    isLogin: localStorage.getItem("isLogin"),
    userInfo:JSON.parse(localStorage.getItem("userInfo")),
    unReadMsdCount:localStorage.getItem("unReadMsdCount"),
    unprocessedCount:localStorage.getItem("unprocessedCount"),
    servicePhone:localStorage.getItem("servicePhone"),
  },

  actions: {},

  mutations: {
    setToken(state, token){
      state.token = token
      localStorage.setItem("token", token);
    },
    setCenterId(state, provider){
      console.log('这是啥', provider)
      state.centerId = provider;
      localStorage.setItem("centerId", provider);
    },
    setServicePhone(state, provider){
      state.servicePhone = provider;
      localStorage.setItem("servicePhone",provider);
    },
    setUnReadMsdCount(state, provider){
      state.unReadMsdCount = provider;
      localStorage.setItem("unReadMsdCount",provider);
    },
    setUnprocessedCount(state, provider){
      state.unprocessedCount = provider;
      localStorage.setItem("unprocessedCount",provider);
    },
    userLogin(state, provider){
      console.log(provider)
      localStorage.setItem('userInfo', JSON.stringify(provider))
      localStorage.setItem("isLogin", true);
      state.isLogin = true;
      state.userInfo = provider
    },
    userLogout(state, provider){
      state.isLogin = false
      state.token = ''
      state.userInfo=""
      state.unReadMsdCount=""
      state.unprocessedCount=""
      state.servicePhone = ''
      localStorage.removeItem("isLogin");
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("unReadMsdCount");
      localStorage.removeItem("unprocessedCount");
      localStorage.removeItem("servicePhone");
    }
  },

  getters: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js